import delegate from "delegate-it";
import easydropdown from "easydropdown-a11y";
import ajax from "@/scripts/common/ajax";
import { scrollToIfNeeded } from "@/scripts/common/scroll-to";
import { generateQueryString } from "@/scripts/common/util";
import { updateQueryParams } from "@/scripts/common/util";

const setupDropdown = (el) => {
  if (el.tagName !== "SELECT") {
    return;
  }

  const opts = {
    behavior: {
      openOnFocus: true,
      maxVisibleItems: 10,
      liveUpdates: true,
      useNativeUiOnMobile: false,
    },
  };

  easydropdown(el, opts);
};

const handleSortChange = (e) => {
  e.target.closest("button").disabled = true;

  const detail = e.detail;
  const groupId = detail.groupId;

  let sortParam = false;

  if (detail.column) {
    sortParam = [detail.column, detail.direction].join("_");
  }

  const url = updateQueryParams([
    ["sort", sortParam],
    ["group", groupId]
  ]);

  window.history.replaceState({}, "", url);

  updateResults(groupId);
};

const handleFilterChange = (e) => {
  e && e.preventDefault();

  const form = e.target.closest('.filter-form');
  const groupId = form.getAttribute('data-group-id');

  const currentUrl = new URL(window.location.href);
  const currentParams = new URLSearchParams(currentUrl.search);
  const currentView = currentParams.get("view");

  const params = new FormData(form);
  const queryString = generateQueryString(params);
  const url = queryString.size ? `${form.action}?${queryString}&group=${groupId}` : `${form.action}?group=${groupId}`;

  window.history.replaceState({}, "", url);

  if (currentView) {
    const url = updateQueryParams([["view", currentView]]);
    window.history.replaceState({}, "", url);
  }

  updateResults(groupId);
};

const handleFilterClear = (e) => {
  const clearButton = e.target.closest('.filter-form-clear');
  const groupId = clearButton.getAttribute('data-group-id');

  const forms = document.querySelectorAll(`.filter-form[data-group-id="${groupId}"]`);

  if (!forms.length) return;

  const currentUrl = new URL(window.location.href);
  const currentParams = new URLSearchParams(currentUrl.search);
  const currentView = currentParams.get("view");

  forms.forEach(form => {
    form.reset();
    form.querySelectorAll('input[type="search"]').forEach((x) => (x.value = null));
    form.querySelectorAll("select").forEach((x) => (x.value = ""));
  });

  const url = `${forms[0].action}?group=${groupId}`;
  window.history.replaceState({}, "", url);

  if (currentView) {
    const url = updateQueryParams([["view", currentView]]);
    window.history.replaceState({}, "", url);
  }

  updateResults(groupId);
};

const updateResults = async (groupId) => {
  const groupContainer = document.querySelector(`[data-group-id="${groupId}"]`).closest('[x-data]');

  if (!groupContainer) {
    console.error(`Could not find container for group ${groupId}`);
    return;
  }

  groupContainer.classList.add("is-loading");

  try {
    const res = await ajax.get(window.location.href).json();

    if (res.error) {
      console.error('Error updating results:', res.error);
      return;
    }

    groupContainer.outerHTML = res.content;

    const newContainer = document.querySelector(`[data-group-id="${groupId}"]`).closest('[x-data]');
    if (newContainer) {
      newContainer.querySelectorAll("select:not([multiple])").forEach((el) => setupDropdown(el));
    }

    if (res.isFiltered) {
      scrollToIfNeeded(groupContainer, 24);
    }
  } catch (error) {
    console.error('Error updating results:', error);
    groupContainer.classList.remove("is-loading");
  }
};

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('.filter-form').forEach(form => {
    form.querySelectorAll("select:not([multiple])").forEach((el) => setupDropdown(el));
  });

  delegate(".filter-form select", "change", handleFilterChange);
  delegate(".filter-form", "submit", handleFilterChange);
  delegate(".filter-form-clear", "click", handleFilterClear);
  delegate("html", "sort:change", handleSortChange);
});
